import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PerPersonnelQueryModel } from '../../personnel-operations/model/per-personnel-query-model';
import { ModalConfig, UiTranslateLoaderService } from 'ui-shared';
import { PersonnelPickerListComponent } from './personnel-picker-list.component';
import {
    CUSTOM_DIALOG_SERVICE,
    HrPersonnelPickerReplaySubjectService,
} from '../service/hr-personnel-picker-replay-subject.service';
import { ReplaySubject, takeUntil } from 'rxjs';
import { PerPersonnelModel } from '../../personnel-operations/model/per-personnel-model';
import { PerPersonnelSearchModel } from '../../personnel-operations/model/hr-per-personnel-search-model';
import { PerPersonnelSearchQueryModel } from '../../personnel-operations/model/hr-per-personnel-search-query-model';

@Component({
    selector: 'personnel-picker-content',
    templateUrl: './personnel-picker-content.component.html',
    providers: [
        {
            provide: CUSTOM_DIALOG_SERVICE,
            useClass: DialogService,
        },
    ],
})
export class PersonnelPickerContentComponent implements OnInit, OnDestroy {
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    selectedPerCountModel = [];
    selectedPersonnel;
    dynamicDialogRef: DynamicDialogRef;
    pickerChipData = this.personnelPicker;
    @Output() valueEvent = new EventEmitter<any>();
    @Output() onSearchPersonnelSelected = new EventEmitter<any>();

    private _personnelPicker: any;
    @Input() set personnelPicker(val: any) {
        if (val === this._personnelPicker) return;
        this._personnelPicker = val;
        this.pickerChipData = val;
        if (this._personnelPicker && this._personnelPicker.length > 0) {
            this.selectedPerCountModel = [{}];
        }
    }

    get personnelPicker(): any {
        if (this.showSelectedPerCount == true) {
            //this.pickerChipData = [new PerPersonnelModel()]
        } else {
            this.pickerChipData = this._personnelPicker;
        }

        return this._personnelPicker;
    }

    private _disabled: boolean = false;
    @Input() set disabled(val: boolean) {
        if (val === this._disabled) return;
        this._disabled = val;
    }

    get disabled(): boolean {
        return this._disabled;
    }

    private _queryModel: PerPersonnelQueryModel;
    @Input() set queryModel(val: PerPersonnelQueryModel) {
        if (val === this._queryModel) return;
        this._queryModel = val;
    }

    get queryModel(): PerPersonnelQueryModel {
        return this._queryModel;
    }

    private _selectionMode: 'single' | 'multiple' | 'select-all';
    @Input() set selectionMode(val: 'single' | 'multiple' | 'select-all') {
        if (val === this._selectionMode) return;
        this._selectionMode = val;
    }

    get selectionMode(): 'single' | 'multiple' | 'select-all' {
        return this._selectionMode;
    }

    private _showSelectedPerCount: boolean = false;
    @Input() set showSelectedPerCount(val: boolean) {
        this._showSelectedPerCount = val;
        if (this.showSelectedPerCount === false && this.selectionMode != 'multiple') {
            this.pickerChipData = this.personnelPicker;
        } else {
            this.pickerChipData = this.selectedPerCountModel;
        }
    }

    get showSelectedPerCount(): boolean {
        return this._showSelectedPerCount;
    }

    @Input() authorizationRoleTypeCodeList: string[] = null;
    @Input() addButtonLabel: string = this.uiTranslateService.instant('addSelected');
    @Input() searchable: boolean = false;
    @Input() searchQueryModel: PerPersonnelSearchQueryModel = new PerPersonnelSearchQueryModel();
    @Input() isIdentityNumberRequired: boolean;
    @Input() showTopOrg = false;
    @Input() rowsPerPageOptions = [];

    @Output() onFilteredPerSelected: EventEmitter<string> = new EventEmitter<string>();
    list = [];
    @Input() showSelectedPersonnel: boolean = false;
    constructor(
        private uiTranslateService: UiTranslateLoaderService,
        protected perPickerReplaySubjectService: HrPersonnelPickerReplaySubjectService,
        @Inject(CUSTOM_DIALOG_SERVICE) private dialogService: DialogService,
    ) {
        this.perPickerReplaySubjectService.onShow$.pipe(takeUntil(this.destroyed$)).subscribe((val) => {
            if (val) {
                this.onShow();
            }
        });
    }

    ngOnInit(): void {
        if (this.personnelPicker && this.personnelPicker.length > 0) {
            this.selectedPerCountModel = [{}];
        }
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    onShow() {
        this.dynamicDialogRef = this.dialogService.open(PersonnelPickerListComponent, {
            width: ModalConfig.MODAL_WIDTH,
            contentStyle: {
                height: ModalConfig.MODAL_MAX_HEIGHT,
                'max-height': ModalConfig.MODAL_MAX_HEIGHT,
                overflow: 'auto',
            },
            data: {
                selectionMode: this.selectionMode,
                queryModel: this.queryModel,
                personnelPickerData: this.personnelPicker,
                authorizationRoleTypeCodeList: this.authorizationRoleTypeCodeList,
                addButtonLabel: this.addButtonLabel,
                isIdentityNumberRequired: this.isIdentityNumberRequired,
                showTopOrg: this.showTopOrg,
                list: this.list,
                rowsPerPageOptions: this.rowsPerPageOptions,
            },
            header: this.uiTranslateService.instant('hrPerPersonnel.pickerHeader'),
        });

        this.dynamicDialogRef.onClose.subscribe((model) => {
            if (model.list?.length == 1) {
                this.onFilteredPerSelected.emit(model.list[0]);
            } else {
                this.onFilteredPerSelected.emit(null);
            }
            if (model.selectedModel) {
                if (this.selectionMode == 'single') {
                    this.personnelPicker = [model.selectedModel];
                    if (this.showSelectedPersonnel) this.selectedPersonnel = model.selectedModel;
                } else {
                    this.personnelPicker = model.selectedModel;
                    if (this.showSelectedPerCount == true) this.pickerChipData = [{}];
                }
                this.valueEvent.emit(model.selectedModel);
            }
            if (this.personnelPicker && this.personnelPicker.length > 0) {
                this.selectedPerCountModel = [{}];
            }
        });
    }

    onRemove(e) {
        if (this.showSelectedPerCount == true && this.selectionMode == 'multiple') {
            this.personnelPicker = [];
        } else {
            this.personnelPicker = this.pickerChipData;
        }

        if (this.selectionMode === 'single') {
            if (this.showSelectedPersonnel) {
                this.selectedPersonnel = null;
            }
            this.valueEvent.emit(null);
        } else {
            this.valueEvent.emit(this.personnelPicker);
        }
    }

    getPerCountText() {
        if (this.personnelPicker.length > 0) {
            return (
                this.personnelPicker.length +
                ' ' +
                this.uiTranslateService.instant('hrPerPersonnel.pickerSelectedPerCount')
            );
        }
        return '';
    }

    onSearchPersonnelSelect(e: PerPersonnelSearchModel) {
        if (e) {
            let model = new PerPersonnelModel();
            let sendModel;
            model.id = e.hrmPerPeopleId;
            model.uuid = e.hrmPerPeopleUuid;
            model.name = e.name;
            model.surname = e.surname;
            model.pictureUuid = e.pictureUuid;
            model.registryNumber = e.registryNumber;
            model.perPersonnelPosition = e.posHrmPerObjectDefText;
            model.perPersonnelOrganization = e.orgHrmPerObjectDefText;
            model.identificationNumber = e.identificationNumber;
            model.active = e.active;
            model.perEmployeeSubtypeId = e.hrmPerEmployeeSubtypeId;
            model.perEmployeeTypeId = e.hrmPerEmployeeTypeId;
            model.gender = e.gender;
            sendModel = [model];
            this.onSearchPersonnelSelected.emit(sendModel);
            if (this.personnelPicker && this.personnelPicker.length > 0 && this.selectionMode == 'multiple') {
                sendModel = [...sendModel, ...this.personnelPicker];
            } else if (this.personnelPicker && this.personnelPicker.length > 0 && this.selectionMode == 'single') {
                sendModel = [...sendModel];
            }
            sendModel = this.removeDuplicates(sendModel, 'id');
            this.valueEvent.emit(sendModel);
            this.personnelPicker = sendModel;
            if (this.showSelectedPersonnel == false) this.selectedPersonnel = null;
        } else if (this.selectionMode == 'single') {
            this.valueEvent.emit(null);
        }
    }
    removeDuplicates(data, key) {
        return [...new Map(data.map((x) => [x[key], x])).values()];
    }
    getChipModel() {
        return this.showSelectedPerCount === false && this.selectionMode != 'multiple'
            ? this.personnelPicker
            : this.selectedPerCountModel;
    }
}
